module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-33.be91116d.png";